module.exports = __webpack_public_path__ + "img/git.66e06c06.svg";